/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Request_PricingInputs */

const en_request_pricing = /** @type {(inputs: Request_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request Pricing`)
};

const es_request_pricing = /** @type {(inputs: Request_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar precio`)
};

const fr_request_pricing = /** @type {(inputs: Request_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander les tarifs`)
};

const de_request_pricing = /** @type {(inputs: Request_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis anfragen`)
};

const ja_request_pricing = /** @type {(inputs: Request_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格をリクエスト`)
};

const zh_request_pricing = /** @type {(inputs: Request_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请求报价`)
};

const ar_request_pricing = /** @type {(inputs: Request_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طلب تسعير`)
};

const id_request_pricing = /** @type {(inputs: Request_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minta Harga`)
};

const it_request_pricing = /** @type {(inputs: Request_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiedi Prezzo`)
};

const ru_request_pricing = /** @type {(inputs: Request_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросить цену`)
};

const pt_request_pricing = /** @type {(inputs: Request_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar Preços`)
};

const ko_request_pricing = /** @type {(inputs: Request_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격 요청하기`)
};

/**
* | output |
* | --- |
* | "Request Pricing" |
*
* @param {Request_PricingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const request_pricing = /** @type {((inputs?: Request_PricingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Request_PricingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_request_pricing(inputs)
	if (locale === "es") return es_request_pricing(inputs)
	if (locale === "fr") return fr_request_pricing(inputs)
	if (locale === "de") return de_request_pricing(inputs)
	if (locale === "ja") return ja_request_pricing(inputs)
	if (locale === "zh") return zh_request_pricing(inputs)
	if (locale === "ar") return ar_request_pricing(inputs)
	if (locale === "id") return id_request_pricing(inputs)
	if (locale === "it") return it_request_pricing(inputs)
	if (locale === "ru") return ru_request_pricing(inputs)
	if (locale === "pt") return pt_request_pricing(inputs)
	return ko_request_pricing(inputs)
});